import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectSettings = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectSettings />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectSettings = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectSettings />
    </Suspense>
  );
};
